import PopupComponent from '../PopupComponent';
import CartController from './cart-controller';

import each from 'lodash/each';
import map from 'lodash/map';

export default class ShoppingPopup extends PopupComponent {
	constructor() {
		super({
			element: '.popup--shopping',
			elements: {
				content: '.popup__content',
				itemList: '.popup__shopping-list',
				items: '.popup__shopping-item',
				backToWebsite: '.popup__shopping-link',
				btnContinueToPayment: '#continue-to-payment',
				totalPrice: '.popup__shopping-price--big',
				shopping: {
					subtotal: '#shopping-subtotal',
					delivery: '#shopping-selected-country',
					total: '#shopping-total',
				},
			},
		});
	}

	create() {
		super.create();
	}

	createHTML(product) {
		console.log(window.isMobile);
		return `
			<div class="popup__shopping-item" data-guid="${product.guid}">
				<span class="popup__shopping-item-title">
					<img src="${'images/store/' + product.number + '/' + 'w507-' + product.images[0].src}" alt="${product.title}">
					<h6>${product.title}</h6>
				</span>
				<div class="popup__shopping-item-quantity">
					<button class="quantity-btn quantity-decrease">−</button>
					<span class="quantity-number">${product.quantity}</span>
					<button class="quantity-btn quantity-increase">+</button>
				</div>
				<span class="popup__shopping-item-size">${
					window.isMobile ? product.size.name.slice(0, 3) : product.size.name
				}</span>
				<span class="popup__shopping-item-frame">${product.frame.name}</span>
				<span class="popup__shopping-item-price">${product.pricestring}</span>
				<span class="popup__shopping-item__cross-wrapper"><svg class="popup__shopping-item__cross-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 15L3 3M15 3L3 15" stroke="rgb(var(--data-color-black))" stroke-linecap="round"></path></svg></span>
			</div>`;
	}

	addProductToDOM(product) {
		const itemHtml = this.createHTML(product);
		this.elements.itemList.insertAdjacentHTML('beforeend', itemHtml);
	}

	addEventListeners() {
		super.addEventListeners();
		this.elements.backToWebsite.addEventListener('click', () => {
			this.hide();
		});
		this.elements.btnContinueToPayment.addEventListener('click', () => {
			this.$emit('viewCheckout');
			this.hide(false);
		});
		this.elements.content.addEventListener('click', ({ target }) => {
			if (
				target &&
				target.classList &&
				(target.classList.contains('popup__shopping-item__cross-icon') ||
					target.classList.contains('popup__shopping-item__cross-wrapper'))
			) {
				const item = target.closest('.popup__shopping-item');
				const productGuid = item.dataset.guid;
				const product = CartController.getCartItems().find(
					(item) => item.guid === productGuid
				);
				CartController.removeFromCart(product);
				item.remove();
				this.$emit('updateUi');
				if (CartController.getCartItems().length === 0)
					this.$emit('closeAllPopups');
			}

			if (
				target &&
				target.classList &&
				target.classList.contains('quantity-decrease')
			) {
				const item = target.closest('.popup__shopping-item');
				const productGuid = item.dataset.guid;
				const product = CartController.getCartItems().find(
					(item) => item.guid === productGuid
				);
				if (product.quantity > 1) {
					product.quantity -= 1;
					item.querySelector('.quantity-number').innerHTML = product.quantity;
					this.$emit('updateUi');
				} else {
					CartController.removeFromCart(product);
					item.remove();
					this.$emit('updateUi');
					if (CartController.getCartItems().length === 0)
						this.$emit('closeAllPopups');
				}
			}

			if (
				target &&
				target.classList &&
				target.classList.contains('quantity-increase')
			) {
				const item = target.closest('.popup__shopping-item');
				const productGuid = item.dataset.guid;
				const product = CartController.getCartItems().find(
					(item) => item.guid === productGuid
				);
				product.quantity += 1;
				item.querySelector('.quantity-number').innerHTML = product.quantity;
				this.$emit('updateUi');
			}
		});
	}

	updateUi() {
		this.elements.shopping.subtotal.innerHTML =
			CartController.getSubtotalPriceString();
		this.elements.shopping.delivery.innerHTML =
			CartController.getDeliveryPriceString();
		this.elements.shopping.total.innerHTML =
			CartController.getTotalPriceString();
	}
	show() {
		super.show();
		this.$emit('stopScroll');
		const domElements = document.querySelectorAll('.popup__shopping-item');
		// remove dom elements
		domElements.forEach((el) => {
			el.remove();
		});

		const cartItems = CartController.getCartItems();
		console.log(cartItems);
		each(cartItems, (product) => {
			this.addProductToDOM(product);
		});

		this.updateUi();
	}

	hide(startScroll = true) {
		super.hide();
		if (startScroll) this.$emit('startScroll');
	}
}
